import styled,  { css } from 'styled-components';
import { FONTS, COLORS } from '@app/src/ui';

interface Props {
  error?: string;
}

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  border: 1px solid ${COLORS.GRAY};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  ${(props:Props) => props.error && css`
    border: 1px solid red;
    margin-bottom: 12px;
    span {
      color: red;
      position: absolute;
      font-size: 11px;
      left: 0;
      width: 100%;
      bottom: 0;
      transform: translateY(100%);
    }
  `}
`;

export const Textarea = styled.textarea`
  margin: 5px 10px 5px 10px;
  border: 0;
  max-width: calc(100% - 20px);
  min-width: calc(100% - 20px);
  font-family: ${FONTS.OPEN_SANS};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: ${COLORS.BLACK};
  outline:none;
  resize: none;
  &::placeholder{
    color: ${COLORS.GRAY_PLACEHOLDER};
  }
`;

export const Title = styled.strong`
  text-transform: uppercase;
  color: ${COLORS.BLACK};
  font-size: 14px;
  margin: 10px 10px 0 10px;
  font-family: ${FONTS.OPEN_SANS};
`;

export const Words = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: ${FONTS.OPEN_SANS};
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: ${COLORS.GRAY_TEXT};
  margin: 5px 0 10px 0;
`;
